import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ResourcesAllocationsApi(): BringozApi {
  return {
    base: `/resourceAllocations`,
    infiniteScroll: {
      address: `/resourceAllocations`,
      cmd: 'GET'
    },
    actions: {
      getResources: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      getResourcesByIds: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      getResourcesAllocationsByAgents: {
        address: 'byAgents',
        cmd: 'GET',
        updateable: true
      },
      createResource: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateResource: {
        address: '{resourceId}',
        cmd: 'POST',
        updateable: true
      },
      duplicateResource: {
        address: '{resourceId}/duplicate',
        cmd: 'POST',
        updateable: true
      },
      deleteResource: {
        address: '{resourceId}',
        cmd: 'DELETE',
        updateable: true
      },
      getAllocationsTimeWindows: {
        address: 'all',
        cmd: 'GET',
        updateable: true
      },
      getAllocations: {
        address: 'allUnified',
        cmd: 'GET',
        updateable: true
      },
      getAllocationsInstances: {
        address: 'instances',
        cmd: 'GET',
        updateable: true
      },
      getResourceAllocationsInstances: {
        address: 'instances',
        cmd: 'GET',
        updateable: true
      },
      createResourceAllocation: {
        address: '{resourceId}',
        cmd: 'PUT',
        updateable: true
      },
      updateResourceAllocation: {
        address: '{resourceId}/{allocationId}',
        cmd: 'POST',
        updateable: true
      },
      deleteResourceAllocation: {
        address: '{resourceId}/{allocationId}',
        cmd: 'DELETE',
        updateable: true
      },
      getAnalysis: {
        address: 'relatedRoutes',
        cmd: 'GET',
        updateable: true
      },
      exportAllocations: {
        address: 'export',
        cmd: 'GET',
        updateable: true
      },
      uploadAllocations: {
        address: 'import',
        cmd: 'POST',
        updateable: true
      },
      getLogsTimeline: {
        address: '{resourceId}/timeline',
        cmd: 'GET',
        updateable: true
      },
      getResourceActiveRoutes: {
        address: '{resourceId}/activeRoutes',
        cmd: 'GET',
        updateable: true
      },
      bulkUpdateTimeWindows: {
        address: 'bulkUpdateTimeWindows',
        cmd: 'POST',
        updateable: true
      },
      bulkUpdateResourceAllocation: {
        address: 'bulk',
        cmd: 'POST',
        updateable: true
      },
      getResourceAllocationInstance: {
        address: '{resourceAllocationInstanceId}',
        cmd: 'GET',
        updateable: true
      },
      getResourceAllocation: {
        address: '{resourceId}/{id}',
        cmd: 'GET',
        updateable: true
      },
      addServiceSequence: {
        address: 'addServiceSequence/{resourceId}/{allocationId}',
        cmd: 'POST',
        updateable: true
      },
      getConnectedResourcesByServiceAreas: {
        address: 'serviceAreaIds',
        cmd: 'POST',
        updateable: false
      },
      exportResources: {
        address: 'export/resources',
        cmd: 'POST',
        updateable: true
      },
      exportResourcesAllocationSequences: {
        address: 'export/sequences',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}
angular
  .module('bringoz.admin.resources')
  .factory('ResourcesAllocationsApi', ResourcesAllocationsApi);
